import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DataService } from './data.service';
import { Person } from 'app/routes/person/person.model';
import { Account } from 'app/routes/account/account.model';
import { map } from 'rxjs/operators';

@Injectable()
export class PersonService extends DataService {
  constructor(http: HttpClient) {
    const personsUrl = environment.api_base_url + '/persons';
    super(personsUrl, http);
  }

  getAllMapped() {
    const projection = '?projection=personProjection';
    return this.getAll(projection).pipe(map((data: any) => { return data._embedded.persons as Person[]; }));
  }

  getPersonByCompany(id) {
    const params = `/search/findByCompany?company_id=${id}`;
    return this.getAll(params).pipe(map((data: any) => { return data._embedded.persons as Person[]; }));
  }

  getInstructors() {
    const params = '/search/instructors';
    return this.getAll(params).pipe(map((data: any) => { return data._embedded.persons as Person[]; }));
  }

  getPersonAccount(personId: number) {
    const params = '/account';
    return this.get(personId, params).pipe(map((data: any) => { return data as Account; }));
  }

  searchAll(searchQuery: any) {
    let searchParams = new URLSearchParams();
    for (let key in searchQuery) {
      searchParams.set(key, searchQuery[key])
    }
    const params = '/search/all?' + searchParams.toString();
    return this.getAll(params).pipe(map((data: any) => { if (data && data._embedded) { return data._embedded.persons as Person[]; } }));
  }

  getAccountPersons() {
    return this.getAll('/account').pipe(map((data: any) => { if (data && data._embedded) { return data._embedded.persons as Person[]; } }));
  }

  getCurrentPerson() {
    return this.getAll('/current').pipe(map((data: any) => { if (data) { return data as Person; } }));
  }
}
